<template>
<div class="infocard">
    <p class="subheader fname">{{f.facility_name}}</p>

    <p class="table-header small-text">
        <span class="mname-header">Наявні препарати</span> <span>Залишок препарату, доз</span>
    </p>
    
    <div v-for="(m, index) in last_r.medicines" :key="index" :class="`medicine-card ${m.open ? 'open' : 'closed'}`">
        <a class="mname-row" @click="clicked(m, index)">
            <span class="mname">{{m.name}} <span class="dosage small-text">{{m.dosage}}</span></span><span class="chevron"></span><span class="unitBalanseEnd">{{ format(sum(m, 'unitBalanseEnd')) }}</span>
        </a>
        <div class="details small-text">
            <p><span class="caption">Форма випуску:</span> <span class="value">{{ m.releaseForm }}</span></p>
            <p><span class="caption">Дозування:</span> <span class="value">{{ m.dosage }}</span></p>
            <p><span class="caption">Виробник:</span> <span class="value">{{ agg(m, 'produser') }}</span></p>
            <p><span class="caption">Серія:</span> <span class="value">{{ agg(m, 'series') }}</span></p>
            <p><span class="caption">Вжити до:</span> <span class="value">{{ agg(m, 'expirationDate') }}</span></p>
            <p><span class="caption">№ наказу МОЗ:</span> <span class="value">{{ agg(m, 'orderNumber') }}</span></p>
            <p><span class="caption">Дата наказу МОЗ:</span> <span class="value">{{ agg(m, 'orderDate') }}</span></p>
            <p><span class="caption">Середньомісячне споживання:</span> <span class="value">{{ `${forecast_map.get(m.medicine) ? fmt0(forecast_map.get(m.medicine).rate) + ' доз' : '?'}` }}</span></p>
            <p><span class="caption">Вистачить на:</span> <span class="value">{{ `${forecast_map.get(m.medicine) ? '~ ' + fmt0(forecast_map.get(m.medicine).months_to_exhaust) + ' місяців' : '?'}` }}</span></p>
            <p class="chart_container"><span class="caption">Графік наявності препарату (місяці):</span> <bar-chart :dataset="chart_data[m.medicine]" /> </p>
        </div>
    </div>
    
    <p class="subheader courses-header">Орієнтовна кількість курсів лікування: 
        <tooltip> 
            <div>
                <p>Орієнтовна кількість курсів розраховується на основі референтних значень кількості доз, потрібних для лікування:</p>
                <br>
                <p>Ентекавір, Ламівудин, Тенофовір – 365 доз\курс</p>
                <p>Пегінтерферон – 48 доз\курс</p>
                <p>Інші препарати – 84 дози\курс</p>
            </div>
        </tooltip>
    </p>
    <courses-table :f="f" :config="config"/>

    <p class="contact-info small-text">Контактна інформація закладу:</p>
    <p class="small-text">{{ f.fullAdress}}</p>
    <p class="small-text last-report">інформація станом на: {{last_r.medicines[0].rows[0].month}}</p>

    <div class="expiration-warning" v-if="forecast_table && forecast_table.length">
        <p>Не встигнуть використати препарати: 
            <tooltip> 
                <div>
                    <p>Орієнтовна кількість препаратів, які можуть не бути використані до завершення терміну придатності. Дані розраховуються на основі використання препаратів закладом охорони здоров’я за останні 12 місяців (за наявності відповідних даних). </p>
                </div>
            </tooltip>
        </p>
        
        <table>
            <!-- <thead></thead> -->
            <tbody>
                <tr v-for="(item, index) in forecast_table" :key="index">
                    <td>{{ item.medicine }}</td> 
                    <!-- <td>{{item.months_to_exhaust}}</td>  -->
                    <!-- <td>{{item.months_to_expiration}}</td> -->
                </tr>

            </tbody>
        </table>    
    </div>

</div>
    
</template>

<script>
import * as d3_array from 'd3-array';
import * as d3 from 'd3';

import BarChart from './BarChart';
import CoursesTable from './CoursesTable';
import Tooltip from './Tooltip';
import { last, timeseries, forecast_expired } from '../utils.js';

const format0 = d3.format(".0f");

export default {
    props: ['f', 'config'],

    components: {
        BarChart,
        CoursesTable,
        Tooltip,
    },

    // mounted() {
    //     console.log(this.forecast_map)
    // },

    data() {
        return {
            selected: null,
        }
    },

    computed: {
        last_r() {
            return last(this.f.reports)
        },

        medicine_date_index() {
            return new Map(this.f.reports.map(r => 
                [r.month, d3_array.rollup(r.medicines, v => v.reduce((o,v) => [...o, ...v.rows], []), m => m.medicine)]
            ))
        },

        forecast() {
            let fcast = forecast_expired(this.f, this.config)
            if (fcast === null || !fcast.length) return null;
            return fcast;
        },

        forecast_table() {
            if (!this.forecast || !this.forecast.length) return null;
            return this.forecast.filter(r => r && r.months_to_exhaust > r.months_to_expiration)
        },

        forecast_map() {
            if (!this.forecast || !this.forecast.length) return new Map()
            let map =  new Map(this.forecast.map(r => [r.medicine, r]))
            return map
        },

        dates() {
            return this.config.dates.map(d => d.substring(0, 7))
        },

        chart_data() {
            let reports = this.f.reports;
            let medicines = this.last_r.medicines.map(m => m.medicine);

            let res = {};

            medicines.forEach(m =>{
                res[m] = [];
                
                this.dates.forEach(d => {
                    let medicines_for_d = this.medicine_date_index.get(d);

                    let value = 0;
                    if (medicines_for_d) {
                        let rows = medicines_for_d.get(m);
                        
                        if (rows && rows.length) {
                            value = d3_array.sum(rows, r => +r.unitBalanseEnd || 0)
                        }
                    }

                    res[m].push({
                        month: d,
                        value: value,
                    })
                })
            });
            return res;
        }
    },

    methods: {
        agg(m, fieldname) {
            //aggregate
            let rows = m.rows;
            let values = rows.map(r => r[fieldname] || '[не вказано]');
            return Array.from(d3_array.union(values)).join(", ")
        },

        sum(m, fieldname) {
            let rows = m.rows;
            let values = rows.map(r => +r[fieldname] || 0);
            return values.reduce((o, v, i) => o + v);
        },

        format: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },

        fmt0: function(x) {
            if (!isFinite(x)) return '∞'
            return format0(x)
            
        },
     
        clicked(m, index){
            this.last_r.medicines.forEach((m, idx) => {
                if (idx!==index) m.open = false
            })
            m.open = !m.open;
        }
    }
}
</script>     

<style lang="scss" scoped>


.table-header {
    color: var(--col-main-grey);

    .mname-header {
        display: inline-block;
        min-width: 32em;

    }
}

.medicine-card {
    color: var(--col-mainblue);
    border-bottom: 1px solid black;
    
    .mname-row {
        cursor: pointer;
        display: block;
        padding: 0.5em 0;
        
        &:hover {
            background-color: var(--col-grey);
        }
    }


    .mname {
        display: inline-block;
        text-transform: uppercase;
        letter-spacing: -0.05em;
        min-width: 25em;

        .dosage {
            color: var(--col-main-grey);
        }
    }

    .unitBalanseEnd {
        display: inline-block;
        margin-left: 1em;
        font-size: 0.8em;
        min-width: 10em;
        text-align: right;
    }

    .details {
        p {
            margin-bottom: 0.3rem;
        }

        .caption {
            color: var(--col-main-grey);
        }
    }

    .details {
        height: 0;
        overflow: hidden;
        transition: height ease-in-out 0.2s;
    }

    $chevron_size: 8px;

    .chevron {
        display: inline-block;
        margin-left: 1em;

        width: 0; 
        height: 0; 
        border-top: $chevron_size solid transparent;
        border-bottom: $chevron_size solid transparent;
        border-left: $chevron_size solid var(--col-orange);

        transition: transform 0.2s
    }

    &.open {
        .details {
            height: auto;
        }
        .chevron {
            transform: rotate(90deg)
        }
    }

    .chart_container {
        margin-top: 1em;
    }

}

.courses-header {
    margin-top: 2em;;
}

.contact-info, .last-report {
    margin-top: 1rem;
    color: var(--col-main-grey);
}

.expiration-warning {
    margin-top: 1rem;
    font-size: 0.7em;
    background-color: rgba(255, 166, 0, 0.3);
    padding: 0.3rem;
    border-radius: 0.3rem;

}

</style>
